import {
  BookOutlined,
  BugOutlined,
  HistoryOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, Tooltip } from 'antd';
import Cookies from 'js-cookie';
import React from 'react';
import { useNavigate } from 'react-router';
import PrometheeLogo from '../../icons/PrometheeLogo';
import NotificationsBell from './NotificationsBell';
import { StyledActionsContainer, StyledHeader } from './styled';

const DashboardHeader = ({
  handleHistoryDrawer,
  handleNotificationDrawer,
  handleDocumentationDrawer,
  profile,
}) => {
  const navigate = useNavigate();
  const dropdownItems = [
    {
      label: `${profile?.given_name} ${profile?.family_name}`,
      key: '0',
      onClick: () => navigate('/dashboard/profile'),
    },
    {
      type: 'divider',
    },
    {
      label: 'Déconnexion',
      icon: <LogoutOutlined />,
      danger: true,
      key: '3',
      onClick: () => {
        const keysToRemove = [
          'oidc.code_verifier.default',
          'oidc.default',
          'oidc.login.default',
          'oidc.nonce.default',
          'oidc.session_state.default',
          'oidc.state.default',
        ];
        // Remove session storage items
        keysToRemove.forEach((key) => {
          sessionStorage.removeItem(key);
        });
        // Remove cookies
        Cookies.remove('sessionid');
        Cookies.remove('csrftoken');
        navigate('/auth/login');
      },
    },
  ];

  return (
    <StyledHeader>
      <PrometheeLogo onClick={() => navigate('/dashboard/products')} />
      <StyledActionsContainer>
        <Tooltip title="Documentation" placement="bottom" color="#f8fff0">
          <Button
            type="text"
            icon={<BookOutlined style={{ fontSize: 20, color: '#f8fff0' }} />}
            onClick={handleDocumentationDrawer}
          />
        </Tooltip>
        <Tooltip title="Signaler un bug" placement="bottom" color="#ff4d4f">
          <Button
            onClick={() => {
              window.open(
                'https://forms.clickup.com/20550237/f/kk4jx-448/J3L1NNBKK05IP8D5D2?CATEGORIE=BUG',
                '_blank'
              );
            }}
            type="text"
            icon={<BugOutlined style={{ fontSize: 20, color: '#ff4d4f' }} />}
          />
        </Tooltip>
        <NotificationsBell onClick={handleNotificationDrawer} />
        <Button
          disabled
          type="text"
          style={{ cursor: 'not-allowed' }}
          icon={<HistoryOutlined style={{ fontSize: 20, color: '#f8fff0' }} />}
          onClick={handleHistoryDrawer}
        />
        <Dropdown
          menu={{ items: dropdownItems }}
          placement="bottomLeft"
          arrow={{ pointAtCenter: true }}
        >
          <Button shape="circle">
            {profile?.given_name?.charAt(0) + profile?.family_name?.charAt(0)}
          </Button>
        </Dropdown>
      </StyledActionsContainer>
    </StyledHeader>
  );
};

export default DashboardHeader;
